"use strict";

exports.__esModule = true;
exports.default = exports.ImageAnswer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _form = require("@jsluna/form");

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ImageAnswer = function ImageAnswer(_ref) {
  var id = _ref.id,
      name = _ref.name,
      onSubmit = _ref.onSubmit,
      disabled = _ref.disabled,
      isRequired = _ref.isRequired;

  var _useState = (0, _react.useState)(!isRequired),
      isValid = _useState[0],
      setIsValid = _useState[1];

  var _useState2 = (0, _react.useState)(undefined),
      file = _useState2[0],
      setFile = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      imagePreviewUrl = _useState3[0],
      setImagePreviewUrl = _useState3[1];

  var onImageChange = function onImageChange(e) {
    var file = e.target.files[0];

    if (file !== undefined) {
      switch (file.type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/gif':
          onSubmit(e.target.files);
          setFile(file); // eslint-disable-next-line no-case-declarations

          var reader = new FileReader();

          reader.onloadend = function () {
            setImagePreviewUrl(reader.result);
          };

          reader.readAsDataURL(file);
          setIsValid(true);
          break;

        default:
          setIsValid(false);
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", null, file !== undefined && /*#__PURE__*/_react.default.createElement("img", {
    alt: "img-preview",
    src: imagePreviewUrl,
    style: {
      width: 150,
      height: 150
    }
  }), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    error: isValid ? '' : _constants.VALIDATION_ERROR,
    type: "file",
    id: id,
    style: {
      display: 'none'
    },
    name: name,
    accept: "image/*",
    onChange: function onChange(e) {
      return onImageChange(e);
    }
  }), file !== undefined ? /*#__PURE__*/_react.default.createElement(_button.LinkButton, {
    onClick: function onClick() {
      return document.getElementById(id).click();
    },
    disabled: disabled,
    name: name
  }, "Replace Image") : /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    onClick: function onClick() {
      return document.getElementById(id).click();
    },
    disabled: disabled,
    name: name
  }, "Upload an Image"));
};

exports.ImageAnswer = ImageAnswer;
ImageAnswer.propTypes = {
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  isRequired: _propTypes.default.bool
};
ImageAnswer.defaultProps = {
  disabled: false,
  isRequired: false
};
var _default = ImageAnswer;
exports.default = _default;